<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">
      <v-col>
        <!-- main text -->
        <v-row>
          <v-col class="pb-0 headline text-uppercase">
            {{ $t('common.process') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="display-1">
            {{ $t('tao.process.subtitle')}}
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col class="text-justify">
            {{ $t('tao.process.text.01')}}
          </v-col>
        </v-row> -->
        <v-row>
          <v-col class="text-justify">
            {{ $t('tao.process.text.02')}}<br>
            {{ $t('tao.process.text.03')}}<br>
            {{ $t('tao.process.text.04')}}
          </v-col>
        </v-row>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'TaoProcess',
    extends: DataComponentBase,

    data: () => ({
      process: [
        {
          title: "mdi-numeric-1",
          class: "text-left",
          text: "energyMonitor.process.step.01.text",
          color: "green",
          img: require("@/assets/img/em-tao-process-01.webp")
        },
        {
          title: "mdi-numeric-2",
          class: "text-right",
          text: "energyMonitor.process.step.02.text",
          color: "indigo",
          img: require("@/assets/img/em-tao-process-02.webp")
        },
        {
          title: "mdi-numeric-3",
          class: "text-left",
          text: "energyMonitor.process.step.03.text",
          color: "amber",
          img: require("@/assets/img/em-tao-process-03.jpeg")
        },
        {
          title: "mdi-numeric-4",
          class: "text-right",
          text: "energyMonitor.process.step.04.text",
          color: "blue",
          img: require("@/assets/img/em-tao-process-04.webp")
        },
      ],

    }),

    methods: {

    },
  }
</script>
